module.exports = __webpack_public_path__ + "static/media/cisLogo.3682a2a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cisLogo.png
// module id = 1039
// module chunks = 0